import { render, staticRenderFns } from "./FreeVideo.vue?vue&type=template&id=1dbaabfa"
import script from "./FreeVideo.vue?vue&type=script&lang=js"
export * from "./FreeVideo.vue?vue&type=script&lang=js"
import style0 from "./FreeVideo.vue?vue&type=style&index=0&id=1dbaabfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports